import styled from "styled-components";
import { motion } from "framer-motion";

export const PG = styled(motion.div)`
    min-width: 295px;
    width: calc(25% - 10px);
    height: 230px;
    border-radius: 10px;
    background: #fff;
    box-sizing: border-box;
    padding: 15px;
    display: flex;
    flex-direction: column;
    /* align-items: center; */
    position: relative;

    @media (max-width: 1180px) {
        width: calc(50% - 10px);
    }
    @media (max-width: 883px) {
        width: auto;
        flex: 1;
    }

    p.PG__title {
        font-weight: 600;
        color: var(--text-color);
        width: 100%;
    }

    div.PG__chart {
        width: 100%;
        height: 155px;
        margin-top: -15px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    div.PG__labels {
        width: 100%;
        display: flex;
        gap: 10px;
        margin-top: 10px;

        div.PG__labels__item {
            display: flex;
            align-items: center;
            gap: 5px;

            div.PG__labels__item__circle {
                width: 12px;
                min-width: 12px;
                height: 12px;
                min-height: 12px;
                background: var(--primary-color);
                border-radius: 100%;
            }

            span.PG__labels__item__lebel {
                font-size: 11px;
                white-space: nowrap;
                color: var(--text-color-light);
                font-weight: 500;
            }
        }
    }
`;